import { render, staticRenderFns } from "./TaskResultsPriceDropMessage.vue?vue&type=template&id=6254f39a&"
import script from "./TaskResultsPriceDropMessage.vue?vue&type=script&lang=js&"
export * from "./TaskResultsPriceDropMessage.vue?vue&type=script&lang=js&"
import style0 from "./TaskResultsPriceDropMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports